import FolderIcon from "./FolderIcon.mjs";

export default class MyNodeIcon extends FolderIcon {}
